export default "__VITE_ASSET__DkSvEu7C__"